import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { TokenCard } from "@/components/TokenCard";
import { TossScoreOrb } from "@/components/TossScoreOrb";
import { BtcCorrelationBadge } from "@/components/BtcCorrelationBadge";
import { SharpeBadge } from "@/components/SharpeBadge";
import { ScoreHelpLink } from "@/components/ScoreHelpLink";
import { ScoreHistoryInline } from "@/components/ScoreHistoryInline";

interface SimpleTokenCardProps {
  name: string;
  symbol: string;
  price: number;
  change24h: number;
  score: number;
}

const formatPrice = (price: number) =>
  price < 1
    ? `$${price.toFixed(6)}`
    : `$${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** TOSS Opportunities view of the shared TokenCard. */
export const SimpleTokenCard = ({ name, symbol, price, change24h, score }: SimpleTokenCardProps) => {
  const validChange = !isNaN(change24h) && isFinite(change24h);
  const validScore = !isNaN(score) && isFinite(score) && score > 0;

  return (
    <TokenCard
      symbol={symbol}
      name={name}
      price={formatPrice(price)}
      changes={validChange ? [{ label: "24h", value: change24h }] : []}
      badges={
        <>
          <BtcCorrelationBadge symbol={symbol} variant="compact" />
          <SharpeBadge symbol={symbol} variant="compact" />
        </>
      }
      headerRight={
        <>
          {validScore ? (
            <div className="flex items-center gap-1">
              <TossScoreOrb score={score} size="sm" showLabel={false} />
              <ScoreHelpLink label="How the TOSS score is calculated" />
            </div>
          ) : (
            <Badge variant="outline" className="font-bold">
              Analyzing…
            </Badge>
          )}
          <ScoreHistoryInline symbol={symbol} />
        </>
      }
      footer={
        <Button
          onClick={() => window.open("https://trade.swyftx.com/register/?ref=lovable", "_blank")}
          className="w-full gap-2 bg-gradient-primary hover:opacity-90"
          size="sm"
        >
          <ExternalLink className="w-4 h-4" />
          Buy on Swyftx
        </Button>
      }
    />
  );
};
